import { BaseService } from "services/_baseService";

class RoomAllocationsAdminService extends BaseService<any> {
    constructor() {
        super(`room-allocations`);
    }
}

export default new RoomAllocationsAdminService();
